export function fmtA3Cantidad(v) {
  if (v === undefined || v === null || v === "") return "—";
  const n = Number(v);
  return Number.isFinite(n)
    ? n.toLocaleString("es-ES", { maximumFractionDigits: 4 })
    : "—";
}

export function fmtA3Importe(v) {
  if (v === undefined || v === null || v === "") return "—";
  const n = Number(v);
  return Number.isFinite(n)
    ? n.toLocaleString("es-ES", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "—";
}

export function resolveUnitPriceStable(
  unidades,
  precioUn,
  totalDocumento,
  totalLinea,
) {
  const u = Number(unidades);
  const p = Number(precioUn);
  const td = Number(totalDocumento);
  const tl = Number(totalLinea);
  const hasU = Number.isFinite(u) && u > 0;
  const hasP = Number.isFinite(p);
  const hasTd = Number.isFinite(td);
  const hasTl = Number.isFinite(tl);
  const base = hasTd ? td : hasTl ? tl : null;
  if (!hasU) return hasP ? p : null;
  if (!hasP && base != null) return Number((base / u).toFixed(6));
  if (hasP && base != null) {
    const implied = Number((base / u).toFixed(6));
    if (Math.abs(implied - p) > 0.01) return implied;
  }
  return hasP ? p : base != null ? Number((base / u).toFixed(6)) : null;
}

export function fmtA3PorcIva(v) {
  if (v === undefined || v === null || v === "") return "—";
  const n = Number(v);
  return Number.isFinite(n)
    ? `${n.toLocaleString("es-ES", { maximumFractionDigits: 2 })} %`
    : "—";
}

export function isA3Served(estado, detalle) {
  const s = String(estado || "")
    .trim()
    .toUpperCase();
  const d = String(detalle || "")
    .trim()
    .toUpperCase();
  return s === "S" || d === "S" || s.includes("SERV") || d.includes("SERV");
}

export function a3EstadoBadgeSx(estado, detalle) {
  const s = String(estado || "").trim();
  const d = String(detalle || "").trim();
  if (!s && !d) return { bgcolor: "grey.200", color: "text.secondary" };
  if (isA3Served(estado, detalle))
    return { bgcolor: "success.main", color: "common.white" };
  return { bgcolor: "warning.main", color: "common.white" };
}

export function fmtA3Estado(estado, detalle) {
  const s = String(estado || "").trim();
  const d = String(detalle || "").trim();
  if (!s && !d) return "";
  return isA3Served(estado, detalle) ? "S" : "A";
}

export function etiquetaMonedaResumen(code) {
  const c = String(code || "")
    .trim()
    .toUpperCase();
  if (!c) return "";
  if (c === "EURO" || c === "EUR") return "€";
  if (c === "USD") return "$";
  return c;
}

export function truncA3(value, max = 35) {
  const txt = String(value || "").trim();
  if (!txt) return "—";
  return txt.length > max ? `${txt.slice(0, max)}...` : txt;
}

export function parsePresupuestoDecimalOrNull(val) {
  if (val === "" || val === undefined || val === null || Number.isNaN(parseFloat(val))) {
    return null;
  }
  return parseFloat(val);
}
